import React from "react";
import { TbMail, TbPhone } from "react-icons/tb";
import {
  Avatar,
  Col,
  Flex,
  Gap,
  Row,
  Typography,
} from "../../../../ppui";
import { Icon } from "../../../../ppui/icon";
import { shortFormName } from "../../../../utils/common";
import { CardViewBox, CardViewBoxBorder } from "../../../style";

const OwnershipList = ({ resource }) => {
  if (!resource) {
    throw new Promise(() => {});
  }

  return (
    <>
      <Flex justifyContent="space-between" gap="10">
        <Typography variant="h5" mb="0">
          Ownership Information
        </Typography>
      </Flex>

      {resource?.ownerships?.length > 0 ? (
        <>
          <Gap height={30} />
          <Row rowGap mb={20}>
            {resource?.ownerships.map((item, index) => (
              <Col sm={12} md={6} lg={6} xl={6} xxl={6} key={index}>
                <CardViewBox>
                  {/* Header Section */}
                  <Row alignItem="center" mb={15}>
                    <Col sm={12} md="auto">
                      <Avatar
                        initials={shortFormName(item?.name || "N/A")}
                        color="primary"
                      />
                    </Col>
                    <Col sm={12} md={6} lg={6} xxl={4}>
                      <Typography
                        variant="body1"
                        strong
                        mb="0"
                        color="primary"
                      >
                        {item?.name ?? "N/A"}
                      </Typography>
                      <Typography
                        variant="body2"
                        mb="0"
                        color="dark"
                        Colorvariant="light"
                      >
                        {item?.designation ?? "N/A"}
                      </Typography>
                    </Col>
                    {/* <Col sm="auto" ml="auto">
                      
                    </Col> */}
                  </Row>

                  <CardViewBoxBorder />

                  {/* Contact Information */}
                  <Flex alignItem="center" gap="5">
                    <Icon size="sm">
                      <TbPhone />
                    </Icon>
                    <Typography variant="body2" mb="0">
                      {item?.phone || "N/A"}
                    </Typography>
                  </Flex>

                  <Flex alignItem="center" gap="5">
                    <Icon size="sm">
                      <TbMail />
                    </Icon>
                    <Typography variant="body2" mb="0">
                      {item?.email || "N/A"}
                    </Typography>
                  </Flex>

                  <CardViewBoxBorder />

                  {/* Additional Information */}
                  <Row mb={10}>
                    <Col sm="auto">
                      <Typography variant="body2" mb="0">
                        PAN: {item?.pan || "N/A"}
                      </Typography>
                    </Col>
                    <Col sm="auto">
                      <Typography variant="body2" mb="0">
                        ID No: {item?.identity_no || "N/A"}
                      </Typography>
                    </Col>
                  </Row>
                </CardViewBox>
              </Col>
            ))}
          </Row>
        </>
      ) : (
        <Typography variant="body2" color="dark">
          No ownership information available.
        </Typography>
      )}
    </>
  );
};

export default OwnershipList;
